"use client";

import { attemptChunkLoadReload } from "@/lib/errors/chunk-load-reload-guard";
import { isChunkLoadError } from "@/lib/errors/is-chunk-load-error";
import { useEffect } from "react";

function _isChunkLoadError(input: unknown): boolean {
  if (typeof input === "string") {
    return isChunkLoadError({ message: input });
  }

  const error = input as
    | { name?: unknown; message?: unknown; stack?: unknown }
    | undefined;

  return isChunkLoadError({
    name: `${error?.name ?? ""}`,
    message: `${error?.message ?? ""}`,
    stack: `${error?.stack ?? ""}`,
  });
}

function _isWebpackRuntimeCallErrorEvent(event: ErrorEvent): boolean {
  return isChunkLoadError({
    message: event.message,
    stack: event.filename ?? "",
  });
}

export function ChunkLoadRecovery() {
  useEffect(() => {
    const handleWindowError = (event: ErrorEvent) => {
      if (
        _isChunkLoadError(event.error) ||
        _isChunkLoadError(event.message) ||
        _isWebpackRuntimeCallErrorEvent(event)
      ) {
        event.preventDefault();
        attemptChunkLoadReload();
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (_isChunkLoadError(event.reason)) {
        event.preventDefault();
        attemptChunkLoadReload();
      }
    };

    window.addEventListener("error", handleWindowError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleWindowError);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection,
      );
    };
  }, []);

  return null;
}
